
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import InstaImage from "@src/components/InstaImage";
import ShopInfoBox from "@src/components/ShopInfoBox";
import LinkWithThumbnail from "@src/components/LinkWithThumbnail";
import { murakamiMasanori } from "@src/constants/authors";
import { harajukuHitoriHarajukuAloneLunchImage } from "@src/constants/images";
import { meta as rainbowPancakePageMeta } from "./rainbow_pancake.mdx";
import { meta as uzunaomomPageMeta } from "./uzunaomom.mdx";
import { meta as micasadecoPageMeta } from "./micasadeco.mdx";
export const meta = {
  path: "/media/harajuku/hitori",
  title: "【原宿】1人で行くのがオススメの名店ランチ５選",
  description: "食べログ百名店に選ばれるような人気のお店に厳選して、原宿で1人ランチができるお店をご紹介します。その日の気分に合わせて選べるようにジャンルに分けて情報が見れるように掲載。人気のランチメニューも併せて記載しているので、お店に行く前にイメージを持つことができるようになっています。",
  topImg: harajukuHitoriHarajukuAloneLunchImage,
  author: murakamiMasanori,
  tags: ["原宿", "行列店", "人気店", "まとめ記事", "1人メシ"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`食べログ百名店に選ばれるような人気のお店に厳選して、原宿で 1 人ランチができるお店をご紹介します。`}</p>
    <p>{`その日の気分に合わせて選べるようにジャンルに分けて情報が見れるように掲載。中には、百名店に三年連続選出されていたり、食べログの評価も高評価のお店を多数ご紹介。`}</p>
    <p>{`カウンター席を中心として店内情報や、人気のランチメニューを写真付きで併せて記載しているので、1 人でランチに行く際にはお店に行く前にイメージを持ってお越しください。`}</p>
    <h2>{`【カレー】みのりんご`}</h2>
    <InstaImage postId="B_msNzYAyA9" mdxType="InstaImage" />
    <p>{`原宿で人気の座を獲得し続けているカレーの名店がみのりんご。原宿駅の改札を左にずっとまっすぐ進んだ徒歩 3 分の距離にあり、竹下通りの喧騒からは少し離れているので、落ち着い他雰囲気のお店です。
食べログの評価は 3.7 を超えるなど、ランチ激戦区の原宿ランチで名実ともに名高いお店です。`}</p>
    <h3>{`1 人で入りやすいカウンター席`}</h3>
    <p>{`みのりんご はカウンター 11 席とテーブル席が 2 席なので、1 人でも気軽にランチに行けるのが特徴。カウンター席の方が多いので、1 人で来られるお客様も多く、気軽に 1 人でランチに行きやすい店内になっています。`}</p>
    <h3>{`人気のランチメニュー`}</h3>
    <InstaImage postId="CA1bIQdAi4Y" mdxType="InstaImage" />
    <p>{`温玉のせとろーりチーズのキーマカレーが、みのりんご の 1 番人気のランチメニュー。注文を受けてから作るチーズのまろやかさと、数十時間かけて作るスパイスの効いたキーマが混ざり合う人気間違いなしの一品。`}</p>
    <ShopInfoBox shopId="br5tsra23akg00ac688g" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【焼き鳥】鳥政`}</h2>
    <InstaImage postId="B7V9sZuFduE" mdxType="InstaImage" />
    <p>{`原宿から表参道方面に 10 分ほど歩くと、高級感のある外観をした焼き鳥屋さんが「鳥政」。高級感があって一見入りづらいかもしれないですが、ランチは 1,000 円前後でボリューム感のあるランチが食べられるということで、コスパがいいお店として人気が続いている名店です。
食べログの評価は 3.7 越えと、名実ともに原宿ランチを牽引する存在。`}</p>
    <h3>{`1 人で入りやすいカウンター席`}</h3>
    <p>{`カウンター席がメインの店内なので、お 1 人様でもランチで使い勝手が良いのが特徴。カウンター 10 席、テーブル６席という内装なので、お 1 人様のお客様がたくさん来店しているので、1 人でも安心なのが特徴。`}</p>
    <h3>{`人気のランチメニュー`}</h3>
    <InstaImage postId="BpNY-ssA-T9" mdxType="InstaImage" />
    <p>{`5 種類のボリューム感のある鶏肉がふんだんに使われた丼と、味噌汁、副菜がついたランチメニューで、1,350 円。実際食べてみるとタレの味とご飯がマッチし、写真で見るよりもボリューム感があって食べ応えがあり、コスパがいいです。`}</p>
    <ShopInfoBox shopId="brgc60a23akg00bq2p00" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【タイ料理】カフィアライム`}</h2>
    <InstaImage postId="BwHqjXNnPhH" mdxType="InstaImage" />
    <p>{`原宿で 1 番人気のタイ料理のお店が、カフィアライム。夏の時期になってくるとタイ料理が食べたくなる方も多くなり、夏の時期には特に人気のお店。
食べログの評価も 3.6 を超えているなど、長い間原宿で愛され続けている名店です。`}</p>
    <h3>{`1 人で入りやすい店内`}</h3>
    <p>{`一階のベトナム料理店チャオバンブーはランチタイムでも行列ができていて入りづらいですが、カフィアライムはチャオバンブーの二階に席があり、普段は待ち時間なしで入れることが多く、隠れ家的な場所なので 1 人でも入りやすい店内になっております。`}</p>
    <h3>{`人気のランチメニュー`}</h3>
    <InstaImage postId="B8H2eaVD1LV" mdxType="InstaImage" />
    <p>{`香草カレーとトムカーガイのメニュー。タイ料理独特の華やかな香りのたつメニューを、日本で 1 人で気軽に楽しめるのは嬉しいですよね。
パッタイやトムヤムクンなどのメニューも取り揃えているので、タイ料理を食べたくなった時には、カフィアライムにランチで行ってみてはいかがでしょうか。`}</p>
    <ShopInfoBox shopId="brgc72i23akg00bq2p30" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【カフェ】レフェクトワール`}</h2>
    <InstaImage postId="B9_kxsAn0SO" mdxType="InstaImage" />
    <p>{`原宿駅から徒歩 4 分のタケオキクチビルの三階にあるレフェクトワールでは、ガラス張りのビルの中にあるので、外から発見することは難しく、知る人ぞ知る穴場のお店です。`}</p>
    <p>{`食べログの評価は 3.7 を超えており、3 年連続百名店に選出されているなど、ランチ激戦区の原宿でもずっと人気のお店になっています。`}</p>
    <h3>{`テイクアウトが多くランチは穴場`}</h3>
    <InstaImage postId="B9dV77_ghFv" mdxType="InstaImage" />
    <p>{`ランチ期はテイクアウトのお客様が多く、イートインスペースは比較的空いていて、お 1 人様の席もたくさんあって入りやすいのが特徴。
ガッツリランチを食べるほどではないけど、軽く食べておきたい時に、カフェは使い勝手が良くて嬉しいですよね。`}</p>
    <h3>{`リーズナブルなランチメニュー`}</h3>
    <p>{`サラダとドリンクのランチセットが 1,020 円でお手頃な価格で食べられます。
メインは、クロックムッシュやキッシュ、サラダ、スープの 4 種類から選べ、パンやマフィンも豊富にあるので、その日の気分に合わせて選んでみてください、`}</p>
    <ShopInfoBox shopId="brf4aea23akg00d4drsg" mdxType="ShopInfoBox" />
    <hr></hr>
    <h2>{`【カフェ】ミカサデコ＆カフェ`}</h2>
    <InstaImage postId="B-ZnzvKHE90" mdxType="InstaImage" />
    <p>{`裏原の通りに位置する隠れ家的なお店なので、初めて訪れる方は少し見つけるのが難しいかもしれませんが、お 1 人様は入りやすいお店です。
マンションのようなビルの建物の一階の路面店に位置するお店で、ふわふわパンケーキ、ビーフストロガノフ、カレーなどメニューも豊富なのが特徴。`}</p>
    <h3>{`1 人でも入りやすいお店のコンセプト`}</h3>
    <p>{`大人が楽しめるカフェをコンセプトにしており、青を基調とした都会的だが落ち着いたデザインの店内は、都会の喧騒を離れてゆっくり 1 人でランチを食べたい方にはおすすめのお店です。`}</p>
    <h3>{`テイクアウトでも使える`}</h3>
    <InstaImage postId="CBAJNHsAF9n" mdxType="InstaImage" />
    <p>{`1 人ランチでお店に入って食べるのよりも、ゆっくり家や仕事場などで食べたい時には、テイクアウトがオススメです！1,000 円前後で羅テイクアウトをすることができ、1 人でランチする際にはかなり役立ちます。`}</p>
    <ShopInfoBox shopId="breespi23akg00eoptr0" mdxType="ShopInfoBox" />
    <hr></hr>
    <h3>{`おわりに　`}</h3>
    <p>{`原宿で 1 人ランチができるお店をご紹介してきましたが、いかがでしたでしょうか。人混みで名店はどこも行列のイメージがある原宿ですが、1 人ランチでも入れるお店が思ったよりもたくさんあるのが特徴です。その日の気分に合わせてジャンルを選び、お 1 人で素敵なランチの時間を楽しんでください！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;